import './index.scss';

const Index = (props: any) => {
  const { text } = props;
  return (
    <div className="staff_end">
      <img src={require('@/images/common/over.png')} alt="" />
      <p>{text}</p>
    </div>
  );
};

export default Index;
